var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_836_12615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_836_12615",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_836_12615",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_836_12615",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA5FJREFUeJztm8FrFGcYxp/3W7Gt290YyFKyCVYktLY28aA99dSDB40KdXRrc9GDIP4XPfkHeCg9hJZCY9vNRg+2WqhBCShKKaK0VGlBCu4uSUsxmUm01v3eHpJxx9XNN+7OfK+V7weBmXe+b/I8P7LJBnYIMSkWz6wj//4xZh4DaDMI6+LutQJjCYRfCfiKfP7kDkr34myjOIv610+9Tg19FsDbXYW0xy+cUaP1u94fpoXKtGAjPn+ZGvo7/H/KA8AW1Wh8O4SzL5kWrjEt+CefPUqMLY9P+ToIf3aeLwUYBYC2Nk/pnaX80lEs4MRq24wCiHGw5Rt9VAtKX3ccNEWK+fIYmCYeDViXgNUFGF8CAL0ROblZCw48l+UBoLZQOgngVnNCm017YgjAK5Hj+WdOZZ+7kWPjX6o4Al5onADpANI4AdIBpHECpANI4wRIB5DGCZAOII0TIB1AGidAOoA0ToB0AGmcAOkA0jgB0gGkcQKkA0jjBEgHkMYJkA4gjRMgHUAaJ0A6gDROgHQAaZwA6QDSOAHSAaQxfk4weZiKucpeAB8APLQ8U78B+nTNP3AGILaZxqqA13qmNmV05RsA25cn4UeV+T2ADg/kJn98qMofzs6XbtvKZO0lMJitjGS0voJH5Z+EQe9mNF0dzJaHbeWyImAwWxnRiqcBFFouPVj5ilLQiqYHs5URG9lSFxAp3xcZLxLhUL//96u9PucIdBjAYuR6QSs+b0NCqr8DnlqesURQe6q+d6Eaznx8UcxN/Q7ocwByK9OCVnyxv6e8oz5f+imtjKn9BKxSfnc18C60rq/53iVA7QTgR8a9pOmH/p7ytrRypiLgWcuHSEhIXECn5UNsS0hUQLflQ2xKSExAUuVDbElIREDS5UNsSOhaQFrlQ9KW0JWAtMuHpCmhYwFt3uEFDLUzyfIhNd+7xKx2Awgi417S9H037xjjCLjfPKQ8AAxkT219anlWo/XAm+k0jIl64M0wq1E8LqFPK17534EJwPrItUUYMAog4EbzjN8q5iZvMDUuw3L5kFUkXC7mKj8DeLMZF9dM9zMK0Ig8iLjMcMuD09bKh7SRkEXL470EGjfdyyig7nvjBJ5qc3mOgV02y4fUA2+GgV0A/mqz5LNqsL9suk+sp8cBpoHc5CEGjgA0AlAdhOmGVh/PBvvm4sdOng09E73/8trjxHgfwADA15nUp/WF/V/G2f8fQXmEpXevphsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveblue);
export default __webpack_public_path__ + "static/media/saveblue.5aa970a0650e4a6974cfc08456b5be60.svg";
export { ForwardRef as ReactComponent };